export const cookieBanner = () => {
  const cookieContainer = document.querySelector('[data-js-cookie-banner]');
  const cookieAcceptBtn = document.querySelector('[data-js-cookie-button]');

  if (!cookieContainer || !cookieAcceptBtn) {
    return;
  }

  cookieAcceptBtn.addEventListener('click', () => {
    cookieContainer.classList.remove('active');
    localStorage.setItem('cookieBannerDisplayed', 'true');
  });

  setTimeout(() => {
    if (!localStorage.getItem('cookieBannerDisplayed')) {
      cookieContainer.classList.add('active');
    }
  }, 2000);
};
